import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Switch } from "components/ui/switch";

import {
  FormikMultiSelect,
  toMultiSelectOptions,
} from "@/components/multi-select";

import { DateRangePicker } from "../share-component/data-range-picker";

export const CustomDatasetFilters = ({
  values,
  handleChange,
  handleSubmit,
  definitions,
  time,
  setTime,
  setFieldValue,
  setQueryFilterState,
  resetForm,
  presetRange,
  setPresetRange,
  initialQueryFilterState,
  queryFilterState,
  localStorageKey,
}: any) => {
  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="flex flex-col gap-1.5 w-full col-span-12 sm:col-span-6 lg:col-span-3">
          <Label htmlFor="query">Search</Label>
          <Input
            id="query"
            name="query"
            placeholder="Type to search... "
            type="text"
            value={values.query}
            onChange={(e: any) => {
              handleChange(e);
              handleSubmit();
            }}
          />
        </div>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <FormikMultiSelect
            id="name"
            label="Name"
            options={
              definitions.isSuccess
                ? toMultiSelectOptions(definitions.data.names)
                : []
            }
            fieldName="name"
            handleSubmit={handleSubmit}
            emptyLabel="All names"
          />
        </div>
        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
          <DateRangePicker
            time={time}
            setTime={setTime}
            setFieldValue={setFieldValue}
            handleSubmit={handleSubmit}
            presetRange={presetRange}
            setPresetRange={setPresetRange}
            disabled={values.latestRelease}
            queryFilterState={queryFilterState}
          />
        </div>
      </div>
      <div className="flex items-center gap-2 h-8 mb-4">
        <div className="flex flex-col gap-1.5">
          <div className="flex items-center gap-2 h-8">
            <Switch
              checked={values.latestRelease}
              onCheckedChange={(checked: boolean) => {
                const syntheticEvent = {
                  target: {
                    name: "latestRelease",
                    value: checked,
                    type: "checkbox",
                    checked,
                  },
                };
                handleChange(syntheticEvent);
                handleSubmit();
              }}
              id="latestRelease"
              name="latestRelease"
            />
            <Label htmlFor="latestRelease">Latest Release</Label>
          </div>
        </div>
        <Button
          className="items-center h-7"
          variant="link"
          size="sm"
          id="clearFilters"
          name="clearFilters"
          onClick={() => {
            setTime({ startTime: 0, endTime: 0 });
            setFieldValue("release", "");
            localStorage.removeItem(localStorageKey);
            setQueryFilterState(initialQueryFilterState);
            resetForm();
            handleSubmit();
          }}
        >
          Clear
        </Button>
      </div>
    </>
  );
};
